import {Button, Col, Row, Select, SelectProps, Space, message} from "antd";
import {StyledAvailabiltyFormWrapper} from "../availability.style";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {
  BufferTimeFormSchema,
  BufferTimeFormValuesType,
} from "../availability-validation-schema";
import {CustomInputComponent} from "../../../input/input-component";
import {StyledServiceButtonWrapper} from "../../../../styles/onboarding/onboarding";
import {useAddStartTimeFrequency} from "../../../../react-query-hooks/availability";
import {useGetProfileContext} from "../../../../context/profile/profile-context";

export function StartTimeFrequency() {
  const bookingIntervalOptions: SelectProps["options"] = [
    {
      value: "30",
      label: "None",
    },

    {
      value: "5",
      label: "5 min",
    },
    {
      value: "10",
      label: "10 min",
    },
    {
      value: "15",
      label: "15 min",
    },
    {
      value: "20",
      label: "20 min",
    },
    {
      value: "30",
      label: "30 min",
    },
    {
      value: "45",
      label: "45 min",
    },
    {
      value: "60",
      label: "60 min",
    },
    {
      value: "custom",
      label: "Custom",
    },
  ];
  const {state: profileState} = useGetProfileContext();
  const addBufferTimeMutation = useAddStartTimeFrequency();

  const handleBufferTime = () => {
    const bufferTimeValue = bookingIntervalOptions.find(
      (option) =>
        option.value?.toString() === profileState.profileData.buffer_time?.toString()
    );

    if (bufferTimeValue) {
      return bufferTimeValue.value?.toString();
    } else {
      return "custom";
    }
  };
  const {
    handleSubmit,
    formState: {errors},
    watch,
    control,
    clearErrors,
    setValue,
  } = useForm<BufferTimeFormValuesType>({
    resolver: yupResolver(BufferTimeFormSchema),
    mode: "onChange",
    defaultValues: {
      bufferTime: handleBufferTime(),
      customBufferTime:
        handleBufferTime() === "custom"
          ? profileState.profileData.buffer_time
            ? profileState.profileData.buffer_time
            : 0
          : undefined,
    },
  });
  const onSubmit = async (values: BufferTimeFormValuesType) => {
    // console.log({values});
    const payload = {
      bufferTime:
        values.bufferTime === "custom" && values.customBufferTime
          ? Number(values.customBufferTime)
          : Number(values.bufferTime),
    };

    addBufferTimeMutation.mutate(payload, {
      onSuccess() {
        message.success("Updated successfully!");
      },
    });
  };
  return (
    <StyledAvailabiltyFormWrapper>
      <div>
        <Space size={16} direction="vertical" style={{display: "flex"}}>
          <p
            style={{
              fontSize: "1.6rem",
              fontWeight: 600,
            }}
          >
            Start time increments
          </p>
          <p
            style={{
              fontSize: "1.6rem",
              fontWeight: 400,
            }}
          >
            Set the frequency of available time slots customers see
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row gutter={[10, 24]}>
              <Col span={24} sm={12}>
                <Controller
                  control={control}
                  name="bufferTime"
                  render={({field: {onChange, value}}) => (
                    <>
                      <Select
                        size="large"
                        // defaultValue="lucy"
                        value={value}
                        style={{width: 282}}
                        onChange={(v) => {
                          clearErrors("customBufferTime");
                          setValue("customBufferTime", undefined);
                          onChange(v);
                        }}
                        options={bookingIntervalOptions}
                        placeholder="Select time"
                        status={errors.bufferTime && "error"}
                      />
                      {errors.bufferTime?.message && (
                        <div role="alert" className="ant-form-item-explain-error">
                          {errors.bufferTime?.message}
                        </div>
                      )}
                    </>
                  )}
                />
              </Col>
              {watch("bufferTime") === "custom" && (
                <Col span={24} sm={12}>
                  <CustomInputComponent
                    id="customBufferTime"
                    name="customBufferTime"
                    type="number"
                    //   label="Call duration (In minutes)"
                    placeholder="Start time time increments in minutes"
                    error={errors.customBufferTime?.message}
                    control={control}
                  />
                </Col>
              )}
            </Row>
            <StyledServiceButtonWrapper style={{marginTop: "2.4rem"}}>
              <div>
                <Button
                  loading={addBufferTimeMutation.isLoading}
                  block
                  type="primary"
                  htmlType="submit"
                  size="small"
                  disabled={
                    Object.keys(errors).length > 0 || Object.values(watch()).length < 1
                  }
                >
                  Save changes
                </Button>
              </div>
              {/* <div>
                <Button
                  onClick={() => reset()}
                  block
                  size="small"
                  type="text"
                  danger
                >
                  Discard
                </Button>
              </div> */}
            </StyledServiceButtonWrapper>
          </form>
        </Space>
      </div>
    </StyledAvailabiltyFormWrapper>
  );
}
